export default __webpack_public_path__ + "static/media/training-illustration20.eac4b7dd.png";